import type { FromModel } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Optional } from "@/__main__/data-model.mjs";

const TeamModel = Mapped({
  key: String,
  value: {
    id: Number,
    name: String,
    region: Optional(String),
    tag: String,
    picture_url: String,
    inserted_at: String,
    updated_at: String,
  },
});

export const ProTeams = createModel(TeamModel);

export type ProTeams = FromModel<typeof ProTeams>;
